import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnInit,
  Signal,
  signal,
} from '@angular/core';

import { SlideshowItem } from '../../models/slideshow-item';
import { SlideshowItemComponent } from '../slideshow-item/slideshow-item.component';
import { isApplicationStable, once } from '@web/utils';

@Component({
  selector: 'app-slideshow',
  imports: [SlideshowItemComponent],
  templateUrl: './slideshow.component.html',
  styleUrl: './slideshow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideshowComponent implements OnInit {
  public readonly time = input<number>(5000);
  public readonly items = input.required<SlideshowItem[]>();

  protected readonly currentItem = this.buildCurrentItemSignal();

  private readonly currentItemIndex = signal(0);
  private readonly isApplicationStable = isApplicationStable();

  public ngOnInit(): void {
    this.startSlideshowLoop();
  }

  private buildCurrentItemSignal(): Signal<SlideshowItem> {
    return computed(() => this.items()[this.currentItemIndex()]);
  }

  private startSlideshowLoop(): void {
    this.isApplicationStable.pipe(once()).subscribe(() => {
      setInterval(() => {
        const currentIndex = this.items().indexOf(this.currentItem());
        const nextIndex = currentIndex + 1;

        this.isOutOfBound(nextIndex)
          ? this.setActiveItemIndex(0)
          : this.setActiveItemIndex(nextIndex);
      }, this.time());
    });
  }

  private setActiveItemIndex(index: number): void {
    this.currentItemIndex.set(index);
  }

  private isOutOfBound(nextIndex: number): boolean {
    return this.items().length === nextIndex;
  }
}
